/**
 * Some of the website functions are not supported by IE browsers.
 * Any compatibility issues should be fixed in here if possible.
 */

// Check for IE browser up to version 11
let ieCheck = () => {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");	

	return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
};

// If user uses an IE
if (ieCheck()) {
	window.ieCompatMode = true;

	// The menu does not render correctly when re-opening
	// hence forcing a re-render
	$('.js-mainNavigation').on('click', () => {
		$('.js-mainNavigation').hide().show(0);
	});
} else {
	window.ieCompatMode = false;
}